export const siteInfo = {
  name: '番号吧',
  tagline: '专业番号查询与影片信息平台',
  description: '番号吧是专业的番号查询平台，提供海量番号信息检索、影片详情、演员资料及分类浏览服务。无论你在寻找特定番号还是探索新内容，番号吧都能帮你快速精准找到所需信息，是番号爱好者的首选查询社区。',
  url: 'https://miaoxiaobao.cn',
  email: 'contact@miaoxiaobao.cn',
  founded: '2024',
  stats: {
    totalArticles: 128500,
    totalCategories: 36,
    totalActors: 28400,
    dailyVisitors: 58600,
  },
  features: [
    {
      title: '海量番号库',
      description: '收录超过12万条番号信息，涵盖各大人气厂商与系列，每日持续更新最新发布内容。',
      icon: 'ri-database-2-line',
    },
    {
      title: '精准检索',
      description: '支持番号、演员名、厂商名等多维度搜索，智能匹配帮你快速精准找到目标内容。',
      icon: 'ri-search-eye-line',
    },
    {
      title: '分类浏览',
      description: '八大分类体系，无论是热门推荐、经典回顾还是新人出道，一键筛选轻松浏览。',
      icon: 'ri-stack-line',
    },
    {
      title: '详细资料',
      description: '每部作品均提供完整的影片信息，包括演员阵容、制作团队、时长和评分等。',
      icon: 'ri-file-info-line',
    },
  ],
  testimonials: [
    {
      name: '影迷小K',
      role: '资深番号收藏家',
      content: '番号吧是我每天必上的网站，信息更新快、检索精准，帮我解决了大量找番号的烦恼。强烈推荐给所有番号爱好者！',
      rating: 5,
    },
    {
      name: '午夜电影人',
      role: '影视博主',
      content: '作为影视内容创作者，番号吧是我最依赖的资料库。分类清晰、资料详尽，大大提升了我的内容产出效率。',
      rating: 5,
    },
    {
      name: '樱花纷飞',
      role: '资深用户',
      content: '使用番号吧两年多了，见证了这个平台一步步完善。界面清爽、搜索快速，最关键的是数据全面且准确，真的超级好用！',
      rating: 5,
    },
    {
      name: '东京影迷会',
      role: '社区版主',
      content: '番号吧不仅是个查询工具，更是个有温度的社区。从番号检索到影片讨论，一站式满足所有需求，五星好评！',
      rating: 5,
    },
  ],
  faqs: [
    {
      question: '番号吧是什么？',
      answer: '番号吧是一个专业的番号查询与影片信息平台，提供海量番号信息的检索、影片详情查看、演员资料浏览以及分类筛选服务，帮助用户快速精准地找到所需的番号信息。',
    },
    {
      question: '如何搜索番号？',
      answer: '在首页搜索框输入番号编码（如SSIS-888）、演员名称或厂商名称，系统将自动匹配并展示相关结果。你也可以通过分类标签浏览不同类别的番号作品。',
    },
    {
      question: '番号信息多久更新一次？',
      answer: '番号吧的数据每日更新，确保用户能够第一时间获取最新发布的番号信息。热门番号通常在上线后24小时内完成收录。',
    },
    {
      question: '番号吧是否免费使用？',
      answer: '番号吧所有核心功能均完全免费，用户无需注册即可使用番号搜索、分类浏览、详情查看等全部功能。',
    },
    {
      question: '如何联系番号吧团队？',
      answer: '你可以通过邮箱 contact@miaoxiaobao.cn 与我们取得联系。无论是功能建议、数据反馈还是合作咨询，我们都非常欢迎你的来信。',
    },
  ],
};